import React, {
  useEffect, useState, useRef, useCallback
} from 'react';
import { PromptBox } from '@barges/shared-web';
import { buildExternalRouteTarget, externalRoutes } from '../../../../config/external_routes';
import classes from './classes.module.scss';
import Autocomplete from '../../../header/autocomplete';
import { getAiSearchConfigApi } from '../../../../../common/api/api';

function HeroSearch({ t }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [shouldCloseAutocomplete, setShouldCloseAutocomplete] = useState(false);
  const [emptyError, setEmptyError] = useState(false);
  const [maxQueryLength, setMaxQueryLength] = useState(200);
  const [charLimitError, setCharLimitError] = useState(false);
  const promptRef = useRef();

  useEffect(() => {
    getAiSearchConfigApi()
      .then((config) => {
        if (config?.maxQueryLength) {
          setMaxQueryLength(config.maxQueryLength);
        }
      })
      .catch(() => {});
  }, []);

  const errorMessage = (() => {
    if (emptyError) return t('search_empty_error');
    if (charLimitError) return t('search_char_limit_error', { max: maxQueryLength });
    return null;
  })();

  const handleSearchSubmit = useCallback(() => {
    const value = promptRef.current?.value.trim();
    if (value) {
      setShouldCloseAutocomplete(true);
      window.location.assign(buildExternalRouteTarget(t, externalRoutes.aiSearchResult, {
        queryParams: { q: value }
      }));
    } else {
      setEmptyError(true);
    }
  }, [t]);

  const handleSearchChange = useCallback(() => {
    const value = promptRef.current?.value || '';
    const len = value.length;
    setSearchQuery(value);
    if (emptyError && value.trim()) {
      setEmptyError(false);
    }
    setCharLimitError(len >= maxQueryLength);
    if (shouldCloseAutocomplete) {
      setShouldCloseAutocomplete(false);
    }
  }, [shouldCloseAutocomplete, emptyError, maxQueryLength]);

  return (
    <>
      <PromptBox
        ref={ promptRef }
        maxLength={ maxQueryLength }
        placeholderPrefix={ t('search_placeholder_prefix') }
        placeholderPhrases={ [
          t('search_placeholder_name'),
          t('search_placeholder_situation'),
          t('search_placeholder_question')
        ] }
        onSubmit={ handleSearchSubmit }
        onChange={ handleSearchChange }
        errorMessage={ errorMessage }
        data-testid="hero-banner-prompt-box"
      />
      <Autocomplete
        t={ t }
        query={ searchQuery }
        clickSource="searchbar autocomplete"
        className={ classes.autocompleteSearchBar }
        shouldClose={ shouldCloseAutocomplete }
      />
    </>
  );
}

export default HeroSearch;
